import featureFlags from '#/shared/feature-flags';

const { regionalAgencies } = featureFlags;

export default {
  api: {
    host: regionalAgencies
      ? 'https://ws.trimet.org'
      : 'https://maps.trimet.org',
    paths: {
      plan: '/rtp/gtfs/v1',
    },
  },
};
